// Route params
export const ROUTE_PARAM_ID = ':id';
export const ROUTE_PARAM_SUBTAB = ':subTab?';

// Path routes
export const ROUTE_PATH_CONTENT = 'content';
export const ROUTE_PATH_DOCUMENTS = 'documents';
export const ROUTE_PATH_SERVICES = 'services';
export const ROUTE_PATH_FOOD_BEVERAGES = 'food-beverages';
export const ROUTE_PATH_AUDIOVISUALS = 'audiovisuals';
export const ROUTE_PATH_OTHERS = 'others';
export const ROUTE_PATH_MEETING_SPACES = 'meeting-spaces';
export const ROUTE_PATH_GUEST_ROOMS = 'guest-rooms';
export const ROUTE_PATH_PACKAGES = 'packages';
export const ROUTE_PATH_TEMPLATES = 'templates';
export const ROUTE_PATH_TERMS_AND_CONDITIONS = 'terms-and-conditions';
export const ROUTE_PATH_MEDIA = 'media';
export const ROUTE_PATH_EDOCUMENTS = 'edocuments';
export const ROUTE_PATH_LIST = 'list';
export const ROUTE_PATH_ADD = 'add';
export const ROUTE_PATH_EDIT = 'edit';
export const ROUTE_PATH_GROUPER = 'grouper';
export const ROUTE_PATH_GROUPER_LINKS = 'links';
export const ROUTE_PATH_INTEGRATIONS = 'integrations';
export const ROUTE_PATH_MAIL = 'mail';
export const ROUTE_PATH_MCP = 'mcp';
export const ROUTE_PATH_MANAGEMENT = 'management';
export const ROUTE_PATH_USERS = 'users';
export const ROUTE_PATH_SEGMENTATION_TEAMS = 'segmentation-teams';
export const ROUTE_PATH_CHANNELS = 'channels';
export const ROUTE_PATH_SOURCES = 'sources';
export const ROUTE_PATH_INDUSTRY_TYPES = 'industry-types';
export const ROUTE_PATH_SUBSEGMENTATIONS = 'subsegmentations';
export const ROUTE_PATH_CANCEL_REASONS = 'cancel-reasons';
export const ROUTE_PATH_ORDER_TASK_TYPES = 'order-task-types';
export const ROUTE_PATH_COMMERCIAL_ACTION_CHOICES = 'commercial-action-choices';
export const ROUTE_PATH_AUDIT_LOGS = 'audit-logs';
export const ROUTE_PATH_FINANCE = 'finance';
export const ROUTE_PATH_PAYMENTS = 'payments';
export const ROUTE_PATH_RESERVATIONS = 'reservations';
export const ROUTE_PATH_RESERVATIONS_TASKS = 'tasks';
export const ROUTE_PATH_TAXES = 'taxes';
export const ROUTE_PATH_DIAGRAMMING = 'diagramming';
export const ROUTE_PATH_DIAGRAMS = 'diagrams';
export const ROUTE_PATH_SETUP_TEMPLATE = 'setup-template';
export const ROUTE_PATH_INVENTORY = 'inventory';
export const ROUTE_PATH_FURNITURE = 'furniture';
export const ROUTE_PATH_OBJECTS = 'objects';

// Absolute routes
export const ROUTE_ABS_ROOT = '/';
export const ROUTE_ABS_CONTENT = `/${ROUTE_PATH_CONTENT}`;
export const ROUTE_ABS_DOCUMENTS = `/${ROUTE_PATH_DOCUMENTS}`;
export const ROUTE_ABS_GROUPER = `/${ROUTE_PATH_GROUPER}`;
export const ROUTE_ABS_INTEGRATIONS = `/${ROUTE_PATH_INTEGRATIONS}`;
export const ROUTE_ABS_MCP = `/${ROUTE_PATH_MCP}`;
export const ROUTE_ABS_MANAGEMENT = `/${ROUTE_PATH_MANAGEMENT}`;
export const ROUTE_ABS_FINANCE = `/${ROUTE_PATH_FINANCE}`;

export const ROUTE_ABS_CONTENT_SERVICES = `${ROUTE_ABS_CONTENT}/${ROUTE_PATH_SERVICES}`;
export const ROUTE_ABS_CONTENT_SERVICES_FOOD_BEVERAGES = `${ROUTE_ABS_CONTENT_SERVICES}/${ROUTE_PATH_FOOD_BEVERAGES}`;
export const ROUTE_ABS_CONTENT_SERVICES_FOOD_BEVERAGES_LIST = `${ROUTE_ABS_CONTENT_SERVICES_FOOD_BEVERAGES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_CONTENT_SERVICES_FOOD_BEVERAGES_ADD = `${ROUTE_ABS_CONTENT_SERVICES_FOOD_BEVERAGES}/${ROUTE_PATH_ADD}/${ROUTE_PARAM_SUBTAB}`;
export const ROUTE_ABS_CONTENT_SERVICES_FOOD_BEVERAGES_EDIT = `${ROUTE_ABS_CONTENT_SERVICES_FOOD_BEVERAGES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}/${ROUTE_PARAM_SUBTAB}`;

export const ROUTE_ABS_CONTENT_SERVICES_AUDIOVISUALS = `${ROUTE_ABS_CONTENT_SERVICES}/${ROUTE_PATH_AUDIOVISUALS}`;
export const ROUTE_ABS_CONTENT_SERVICES_AUDIOVISUALS_LIST = `${ROUTE_ABS_CONTENT_SERVICES_AUDIOVISUALS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_CONTENT_SERVICES_AUDIOVISUALS_ADD = `${ROUTE_ABS_CONTENT_SERVICES_AUDIOVISUALS}/${ROUTE_PATH_ADD}/${ROUTE_PARAM_SUBTAB}`;
export const ROUTE_ABS_CONTENT_SERVICES_AUDIOVISUALS_EDIT = `${ROUTE_ABS_CONTENT_SERVICES_AUDIOVISUALS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}/${ROUTE_PARAM_SUBTAB}`;

export const ROUTE_ABS_CONTENT_SERVICES_OTHERS = `${ROUTE_ABS_CONTENT_SERVICES}/${ROUTE_PATH_OTHERS}`;
export const ROUTE_ABS_CONTENT_SERVICES_OTHERS_LIST = `${ROUTE_ABS_CONTENT_SERVICES_OTHERS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_CONTENT_SERVICES_OTHERS_ADD = `${ROUTE_ABS_CONTENT_SERVICES_OTHERS}/${ROUTE_PATH_ADD}/${ROUTE_PARAM_SUBTAB}`;
export const ROUTE_ABS_CONTENT_SERVICES_OTHERS_EDIT = `${ROUTE_ABS_CONTENT_SERVICES_OTHERS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}/${ROUTE_PARAM_SUBTAB}`;

export const ROUTE_ABS_CONTENT_MEETING_SPACES = `${ROUTE_ABS_CONTENT}/${ROUTE_PATH_MEETING_SPACES}`;
export const ROUTE_ABS_CONTENT_MEETING_SPACES_LIST = `${ROUTE_ABS_CONTENT_MEETING_SPACES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_CONTENT_MEETING_SPACES_ADD = `${ROUTE_ABS_CONTENT_MEETING_SPACES}/${ROUTE_PATH_ADD}/${ROUTE_PARAM_SUBTAB}`;
export const ROUTE_ABS_CONTENT_MEETING_SPACES_EDIT = `${ROUTE_ABS_CONTENT_MEETING_SPACES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}/${ROUTE_PARAM_SUBTAB}`;

export const ROUTE_ABS_CONTENT_GUEST_ROOMS = `${ROUTE_ABS_CONTENT}/${ROUTE_PATH_GUEST_ROOMS}`;
export const ROUTE_ABS_CONTENT_GUEST_ROOMS_LIST = `${ROUTE_ABS_CONTENT_GUEST_ROOMS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_CONTENT_GUEST_ROOMS_ADD = `${ROUTE_ABS_CONTENT_GUEST_ROOMS}/${ROUTE_PATH_ADD}/${ROUTE_PARAM_SUBTAB}`;
export const ROUTE_ABS_CONTENT_GUEST_ROOMS_EDIT = `${ROUTE_ABS_CONTENT_GUEST_ROOMS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}/${ROUTE_PARAM_SUBTAB}`;

export const ROUTE_ABS_CONTENT_PACKAGES = `${ROUTE_ABS_CONTENT}/${ROUTE_PATH_PACKAGES}`;
export const ROUTE_ABS_CONTENT_PACKAGES_LIST = `${ROUTE_ABS_CONTENT_PACKAGES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_CONTENT_PACKAGES_ADD = `${ROUTE_ABS_CONTENT_PACKAGES}/${ROUTE_PATH_ADD}/${ROUTE_PARAM_SUBTAB}`;
export const ROUTE_ABS_CONTENT_PACKAGES_EDIT = `${ROUTE_ABS_CONTENT_PACKAGES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}/${ROUTE_PARAM_SUBTAB}`;

export const ROUTE_ABS_DOCUMENTS_MEDIA = `${ROUTE_ABS_DOCUMENTS}/${ROUTE_PATH_MEDIA}`;
export const ROUTE_ABS_DOCUMENTS_MEDIA_LIST = `${ROUTE_ABS_DOCUMENTS_MEDIA}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_DOCUMENTS_EDOCUMENTS = `${ROUTE_ABS_DOCUMENTS}/${ROUTE_PATH_EDOCUMENTS}`;
export const ROUTE_ABS_DOCUMENTS_EDOCUMENTS_LIST = `${ROUTE_ABS_DOCUMENTS_EDOCUMENTS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_DOCUMENTS_EDOCUMENTS_EDIT = `${ROUTE_ABS_DOCUMENTS_EDOCUMENTS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;

// Grouper routes
export const ROUTE_ABS_GROUPER_LINKS = `${ROUTE_ABS_GROUPER}/${ROUTE_PATH_GROUPER_LINKS}`;
export const ROUTE_ABS_GROUPER_LINK = `${ROUTE_ABS_GROUPER}/${ROUTE_PARAM_ID}`;

// Integrations routes
export const ROUTE_ABS_INTEGRATIONS_LIST = `${ROUTE_ABS_INTEGRATIONS}/${ROUTE_PATH_LIST}`;

// Mail routes
export const ROUTE_ABS_MAIL = `/${ROUTE_PATH_MAIL}`;
export const ROUTE_ABS_MAIL_LIST = `${ROUTE_ABS_MAIL}/${ROUTE_PATH_LIST}`;

// Documents routes
export const ROUTE_ABS_DOCUMENTS_TEMPLATES = `${ROUTE_ABS_DOCUMENTS}/${ROUTE_PATH_TEMPLATES}`;
export const ROUTE_ABS_DOCUMENTS_TEMPLATES_LIST = `${ROUTE_ABS_DOCUMENTS_TEMPLATES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_DOCUMENTS_TEMPLATES_EDIT = `${ROUTE_ABS_DOCUMENTS_TEMPLATES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_DOCUMENTS_TERMS = `${ROUTE_ABS_DOCUMENTS}/${ROUTE_PATH_TERMS_AND_CONDITIONS}`;
export const ROUTE_ABS_DOCUMENTS_TERMS_LIST = `${ROUTE_ABS_DOCUMENTS_TERMS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_DOCUMENTS_TERMS_EDIT = `${ROUTE_ABS_DOCUMENTS_TERMS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;

// Management routes
export const ROUTE_ABS_MANAGEMENT_USERS_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_USERS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_USERS_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_USERS}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_USERS_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_USERS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_SEGMENTATION_TEAMS_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SEGMENTATION_TEAMS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_SEGMENTATION_TEAMS_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SEGMENTATION_TEAMS}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_SEGMENTATION_TEAMS_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SEGMENTATION_TEAMS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_CHANNELS_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_CHANNELS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_CHANNELS_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_CHANNELS}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_CHANNELS_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_CHANNELS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_SOURCES_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SOURCES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_SOURCES_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SOURCES}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_SOURCES_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SOURCES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_INDUSTRY_TYPES_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_INDUSTRY_TYPES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_INDUSTRY_TYPES_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_INDUSTRY_TYPES}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_INDUSTRY_TYPES_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_INDUSTRY_TYPES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_CANCEL_REASONS_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_CANCEL_REASONS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_CANCEL_REASONS_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_CANCEL_REASONS}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_CANCEL_REASONS_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_CANCEL_REASONS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_SUBSEGMENTATIONS_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SUBSEGMENTATIONS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_SUBSEGMENTATIONS_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SUBSEGMENTATIONS}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_SUBSEGMENTATIONS_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_SUBSEGMENTATIONS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_ORDER_TASK_TYPES_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_ORDER_TASK_TYPES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_ORDER_TASK_TYPES_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_ORDER_TASK_TYPES}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_ORDER_TASK_TYPES_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_ORDER_TASK_TYPES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_COMMERCIAL_ACTION_CHOICES_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_COMMERCIAL_ACTION_CHOICES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_MANAGEMENT_COMMERCIAL_ACTION_CHOICES_ADD = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_COMMERCIAL_ACTION_CHOICES}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_MANAGEMENT_COMMERCIAL_ACTION_CHOICES_EDIT = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_COMMERCIAL_ACTION_CHOICES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_MANAGEMENT_AUDIT_LOGS_LIST = `${ROUTE_ABS_MANAGEMENT}/${ROUTE_PATH_AUDIT_LOGS}/${ROUTE_PATH_LIST}`;

// Finance routes
export const ROUTE_ABS_FINANCE_PAYMENTS_LIST = `${ROUTE_ABS_FINANCE}/${ROUTE_PATH_PAYMENTS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_FINANCE_PAYMENTS_ADD = `${ROUTE_ABS_FINANCE}/${ROUTE_PATH_PAYMENTS}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_FINANCE_PAYMENTS_EDIT = `${ROUTE_ABS_FINANCE}/${ROUTE_PATH_PAYMENTS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_FINANCE_TAXES_LIST = `${ROUTE_ABS_FINANCE}/${ROUTE_PATH_TAXES}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_FINANCE_TAXES_ADD = `${ROUTE_ABS_FINANCE}/${ROUTE_PATH_TAXES}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_FINANCE_TAXES_EDIT = `${ROUTE_ABS_FINANCE}/${ROUTE_PATH_TAXES}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;

// Reservations routes
export const ROUTE_ABS_RESERVATIONS = `/${ROUTE_PATH_RESERVATIONS}`;
export const ROUTE_ABS_RESERVATIONS_LIST = `${ROUTE_ABS_RESERVATIONS}/${ROUTE_PATH_LIST}`;
export const ROUTE_ABS_RESERVATIONS_TASKS_LIST = `${ROUTE_ABS_RESERVATIONS}/${ROUTE_PATH_RESERVATIONS_TASKS}`;
export const ROUTE_ABS_RESERVATIONS_TASKS_ADD = `${ROUTE_ABS_RESERVATIONS}/${ROUTE_PATH_RESERVATIONS_TASKS}/${ROUTE_PATH_ADD}`;
export const ROUTE_ABS_RESERVATIONS_TASKS_EDIT = `${ROUTE_ABS_RESERVATIONS}/${ROUTE_PATH_RESERVATIONS_TASKS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;

// Diagramming routes
export const ROUTE_ABS_DIAGRAMMING = `/${ROUTE_PATH_DIAGRAMMING}`;
export const ROUTE_ABS_DIAGRAMMING_DIAGRAMS = `${ROUTE_ABS_DIAGRAMMING}/${ROUTE_PATH_DIAGRAMS}`;
export const ROUTE_ABS_DIAGRAMMING_SETUP_TEMPLATE = `${ROUTE_ABS_DIAGRAMMING}/${ROUTE_PATH_SETUP_TEMPLATE}`;
export const ROUTE_ABS_DIAGRAMMING_INVENTORY = `${ROUTE_ABS_DIAGRAMMING}/${ROUTE_PATH_INVENTORY}`;
export const ROUTE_ABS_DIAGRAMMING_INVENTORY_SUBTAB = `${ROUTE_ABS_DIAGRAMMING_INVENTORY}/${ROUTE_PARAM_SUBTAB}`;
export const ROUTE_ABS_DIAGRAMMING_INVENTORY_OBJECTS = `${ROUTE_ABS_DIAGRAMMING_INVENTORY}/${ROUTE_PATH_OBJECTS}`;
export const ROUTE_ABS_DIAGRAMMING_INVENTORY_FURNITURE_EDIT = `${ROUTE_ABS_DIAGRAMMING_INVENTORY}/${ROUTE_PATH_FURNITURE}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
export const ROUTE_ABS_DIAGRAMMING_INVENTORY_OBJECTS_EDIT = `${ROUTE_ABS_DIAGRAMMING_INVENTORY}/${ROUTE_PATH_OBJECTS}/${ROUTE_PARAM_ID}/${ROUTE_PATH_EDIT}`;
